document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('promoModal');
  const modalBody = document.getElementById('promoModalBody');
  const closeBtn = document.querySelector('.promo-modal-close');

  const contentMap = {
    canada: `
      <h3>Every Step Made in Canada</h3>
      <p>From the materials to the craftsmanship, every pair of Bucks Boots is proudly made in Canada. We source local materials and manufacture at our Canadian facility to ensure quality and comfort in every step.</p>
    `,
    comfort: `
      <h3>30-Day Comfort Guarantee</h3>
      <p>Try your Bucks Boots risk-free. If they're not as comfortable as expected, return them within 30 days. Applies to regular stock items.</p>
    `
  };

  document.querySelectorAll('.open-promo-modal').forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();
      const type = this.getAttribute('data-modal-content');
      modalBody.innerHTML = contentMap[type] || '';
      modal.style.display = 'block';
    });
  });

  closeBtn.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  window.addEventListener('click', (e) => {
    if (e.target == modal) {
      modal.style.display = 'none';
    }
  });

   
  document.querySelectorAll('a[href="#comfort"], a[href="#canada"]').forEach(link => {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      const type = this.getAttribute('href').replace('#', '');
      modalBody.innerHTML = contentMap[type] || '';
      modal.style.display = 'block';
    });
  });


});
